var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5113_13795",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5113_13795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 14.167L10.0003 11.167L13.0003 14.167L14.167 13.0003L11.167 10.0003L14.167 7.00033L13.0003 5.83366L10.0003 8.83366L7.00033 5.83366L5.83366 7.00033L8.83366 10.0003L5.83366 13.0003L7.00033 14.167ZM10.0003 18.3337C8.84755 18.3337 7.76421 18.1149 6.75033 17.6774C5.73644 17.2399 4.85449 16.6462 4.10449 15.8962C3.35449 15.1462 2.76074 14.2642 2.32324 13.2503C1.88574 12.2364 1.66699 11.1531 1.66699 10.0003C1.66699 8.84755 1.88574 7.76421 2.32324 6.75033C2.76074 5.73644 3.35449 4.85449 4.10449 4.10449C4.85449 3.35449 5.73644 2.76074 6.75033 2.32324C7.76421 1.88574 8.84755 1.66699 10.0003 1.66699C11.1531 1.66699 12.2364 1.88574 13.2503 2.32324C14.2642 2.76074 15.1462 3.35449 15.8962 4.10449C16.6462 4.85449 17.2399 5.73644 17.6774 6.75033C18.1149 7.76421 18.3337 8.84755 18.3337 10.0003C18.3337 11.1531 18.1149 12.2364 17.6774 13.2503C17.2399 14.2642 16.6462 15.1462 15.8962 15.8962C15.1462 16.6462 14.2642 17.2399 13.2503 17.6774C12.2364 18.1149 11.1531 18.3337 10.0003 18.3337Z",
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.e6f3c874cfb538a438a49f8c7c5805f4.svg";
export { ForwardRef as ReactComponent };